import APIClient from '@/shared/http/clients/api'

const resourceName = 'DespesaRecibos'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllByDespesa = (despesaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllByDespesa/${despesaId}`, data, config)
const SendFile = (despesaId, data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/SendFile/${despesaId}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const DeleteFile = (despesaId, data = {}, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/DeleteFile/${despesaId}`, data, config)

const ExpenseReceiptsRepository = {
  GetAllByDespesa,
  SendFile,
  DeleteFile
}

export default ExpenseReceiptsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/expensereceipts.js